import { render, staticRenderFns } from "./ScreeningUnAdd.vue?vue&type=template&id=69c6d94c&scoped=true&"
import script from "./ScreeningUnAdd.vue?vue&type=script&lang=js&"
export * from "./ScreeningUnAdd.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningUnAdd.vue?vue&type=style&index=0&id=69c6d94c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c6d94c",
  null
  
)

export default component.exports